"use client";

import { c as _c } from "react/compiler-runtime";
import { NodeViewWrapper } from "@tiptap/react";
import { cx } from "@/lib/tailwind-utils";
import type { ButtonAttrs } from "./definition";
import { getButtonStyles } from "./styles";
interface Props {
  attrs: ButtonAttrs;
  updateAttrs: (attrs: Partial<ButtonAttrs>) => void;
  selected: boolean;
}
const ALIGNMENT_CLASS: Record<string, string> = {
  left: "text-left",
  center: "text-center",
  right: "text-right"
};
export function ButtonTiptapView(t0) {
  const $ = _c(11);
  const {
    attrs,
    selected
  } = t0;
  const alignmentClass = ALIGNMENT_CLASS[attrs.alignment] ?? "text-center";
  let t1;
  if ($[0] !== attrs) {
    t1 = getButtonStyles(attrs);
    $[0] = attrs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const buttonStyles = t1;
  const t2 = selected && "ring-2 ring-primary/30 rounded";
  let t3;
  if ($[2] !== t2) {
    t3 = cx("inline-block outline-none select-none", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = attrs.text || "Click here";
  let t5;
  if ($[4] !== buttonStyles || $[5] !== t3 || $[6] !== t4) {
    t5 = <span className={t3} style={buttonStyles}>{t4}</span>;
    $[4] = buttonStyles;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== alignmentClass || $[9] !== t5) {
    t6 = <NodeViewWrapper data-block-type="emailButton"><div className={alignmentClass}>{t5}</div></NodeViewWrapper>;
    $[8] = alignmentClass;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}